import React from "react";

const AddBoxForm = ({
  priceForm,
  onChange,
  onSubmit,
  onCancel,
  areas,
  loadingAreas,
}) => {
  const handleChange = (e, isImage = false) => {
    const { name, value, files } = e.target;
    if (isImage) {
      onChange({ target: { name, value: files[0] } }, true);
    } else {
      onChange(e);
    }
  };
  // console.log(priceForm)
  return (
    <form
      onSubmit={onSubmit}
      className="grid grid-cols-2 gap-4 p-6 bg-white rounded-lg shadow-lg w-[90%] max-w-2xl"
    >
      {/* Name Product */}
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black capitalize">
          Name Product
        </label>
        <input
          type="text"
          name="name"
          value={priceForm.name}
          onChange={handleChange}
          required
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      {/* Weight Product (KG) */}
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black capitalize">
          Weight Product (KG)
        </label>
        <input
          type="number"
          name="weight"
          value={priceForm.weight}
          onChange={handleChange}
          required
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      {/* Image Upload Field */}
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black capitalize">
          Image
        </label>
        <input
          type="file"
          name="image"
          accept="image/*"
          onChange={(e) => handleChange(e, true)}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      <div className="flex justify-end col-span-2 mt-2 space-x-3">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-1 text-black bg-gray-300 rounded-md"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-1 text-white rounded-md bg-custom-yellow"
        >
          Save
        </button>
      </div>
    </form>
  );
};

export default AddBoxForm;
